import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'date',
        label: 'Data Emissão',
        field: 'range_emissao'
      }, {
        type: 'date',
        label: 'Data Autorização',
        field: 'range_autorizacao'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Autorizada', 'Cancelada', 'Editando', 'Processando', 'Rejeitada']
      }]
    }
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.duplicarNFSe",
      modifiers: {
        "duplicarNFSe": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length !== 1 || ((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.status) !== 3
    }
  }, [_vm._v(" Duplicar NFSe ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.transmitirNFSesModal",
      modifiers: {
        "transmitirNFSesModal": true
      }
    }],
    attrs: {
      "disabled": ((_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.status) === 3
    }
  }, [_vm._v(" Transmitir NFSe ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "duplicarNFSe",
      "title": "Deseja duplicar a NFSe selecionada?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "doubleNFSe",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.duplicar
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("NFSe a ser duplicada "), _c('p', [_vm._v("Número: " + _vm._s((_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele3 === void 0 ? void 0 : _vm$actionsStore$sele3.numero))])])]), _c('b-modal', {
    attrs: {
      "id": "transmitirNFSesModal",
      "title": "Deseja transmitir a(s) NFSe selecionada(s)?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "transmitirNFSes",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.transmitirNFSes
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("Após enviar as NFSe selecionadas, as mesmas serão precessadas e trasmitidas.")])]), _c('TableApp', {
    ref: "nfselist",
    attrs: {
      "titulo": "NFSe",
      "acaoBtn": "/#/servicos/nova-nfse",
      "textoBtn": "Nova NFSe",
      "api-url": "/nfse/paginate",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " "), props.rowData.confirmacao_abertura_email ? _c('p', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.right",
            value: 'E-mail visualizado',
            expression: "'E-mail visualizado'",
            modifiers: {
              "right": true
            }
          }]
        }, [_c('Mail', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e()])])]) : _vm._e(), props.field == 'cliente' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.cliente) + " ")])])]) : _vm._e(), props.field == 'emissao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "emissao"
          },
          slot: "emissao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.emissao, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'autorizacao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "autorizacao"
          },
          slot: "autorizacao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.autorizacao, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.focus",
            modifiers: {
              "focus": true
            }
          }],
          class: _vm.statusNFseClass(props.rowData.status),
          attrs: {
            "slot": "status",
            "id": "status-ref-".concat(props.rowData.numero)
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusNFseLabel(props.rowData.status)) + " ")]) : _vm._e(), props.rowData.rejeicao_tecnospeed != '' ? _c('b-tooltip', {
          attrs: {
            "target": "status-ref-".concat(props.rowData.numero),
            "placement": "left"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.rejeicao_tecnospeed) + " ")]) : _vm._e(), props.field == 'total_nfse' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "total_nfse"
          },
          slot: "total_nfse"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.total_nfse, 2)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [props.rowData.status === 2 || props.rowData.status === 5 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Copiar JSON enviado à TecnoSpeed',
            expression: "'Copiar JSON enviado à TecnoSpeed'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-secondary btn-hover-secondary btn-icon mr-2",
          attrs: {
            "type": "button",
            "aria-label": "Copiar JSON enviado à TecnoSpeed"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirJsonTecnoSpeed(props.rowData);
            }
          }
        }, [_c('ContentCopy', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), (props.rowData.status === 1 || props.rowData.status === 5) && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar NFSe',
            expression: "'Editar NFSe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleEditNFse(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), (props.rowData.status === 1 || props.rowData.status === 5) && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Excluir NFSe',
            expression: "'Excluir NFSe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteNFse(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), props.rowData.status === 3 && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Cancelar NFSe',
            expression: "'Cancelar NFSe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleCancelNFSe(props.rowData);
            }
          }
        }, [_c('Cancel', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status === 1 || props.rowData.status === 5 || props.rowData.status === 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Consultar NFSe',
            expression: "'Consultar NFSe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleConsultNFSe(props.rowData);
            }
          }
        }, [_c('Magnify', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e(), props.rowData.status === 3 && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Enviar NFSe por email',
            expression: "'Enviar NFSe por email'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleSendEmailNFSe(props.rowData);
            }
          }
        }, [_c('Send', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status === 3 && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Enviar NFSe por whatsapp',
            expression: "'Enviar NFSe por whatsapp'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.shareToWhatsapp(props.rowData);
            }
          }
        }, [_c('Whatsapp', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status === 3 && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Imprimir NFSe',
            expression: "'Imprimir NFSe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleImprimirNFSe(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e(), props.rowData.status === 3 && props.rowData.status !== 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Gerar XML',
            expression: "'Gerar XML'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-hover-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.gerarlXml(props.rowData);
            }
          }
        }, [_c('XMLIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()])])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "title": "JSON de envio à TecnoSpeed",
      "size": "xl",
      "centered": "",
      "no-close-on-backdrop": _vm.jsonTecnoSpeed.salvando,
      "no-close-on-esc": _vm.jsonTecnoSpeed.salvando,
      "hide-header-close": _vm.jsonTecnoSpeed.salvando
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "disabled": _vm.jsonTecnoSpeed.salvando
          },
          on: {
            "click": function click($event) {
              _vm.jsonTecnoSpeedAberto = false;
            }
          }
        }, [_vm._v(" Fechar ")]), _c('b-button', {
          attrs: {
            "variant": "info",
            "disabled": _vm.jsonTecnoSpeed.salvando || !_vm.jsonTecnoSpeed.conteudo.trim()
          },
          on: {
            "click": _vm.copiarDadosTecnoSpeed
          }
        }, [_vm._v(" Copiar JSON ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.jsonTecnoSpeed.salvando
          },
          on: {
            "click": _vm.salvarJsonTecnoSpeed
          }
        }, [_vm._v(" " + _vm._s(_vm.jsonTecnoSpeed.salvando ? "Salvando..." : "Salvar JSON") + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.jsonTecnoSpeedAberto,
      callback: function callback($$v) {
        _vm.jsonTecnoSpeedAberto = $$v;
      },
      expression: "jsonTecnoSpeedAberto"
    }
  }, [_c('p', [_vm._v(" NFSe #" + _vm._s(_vm.jsonTecnoSpeed.id_nfse) + ". Edite os dados e salve para usar as correções na próxima transmissão. Salvar altera somente o JSON de envio. ")]), _c('label', {
    attrs: {
      "for": "nfse-json-tecnospeed"
    }
  }, [_vm._v("JSON de envio")]), _c('b-form-textarea', {
    staticClass: "text-monospace",
    attrs: {
      "id": "nfse-json-tecnospeed",
      "disabled": _vm.jsonTecnoSpeed.salvando,
      "rows": "20",
      "spellcheck": "false"
    },
    model: {
      value: _vm.jsonTecnoSpeed.conteudo,
      callback: function callback($$v) {
        _vm.$set(_vm.jsonTecnoSpeed, "conteudo", $$v);
      },
      expression: "jsonTecnoSpeed.conteudo"
    }
  })], 1), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "nfse"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };